import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import get from 'lodash/get';
import withProductCustomisation from './withProductCustomisation';
import withQueryParams from './withQueryParams';
import withProducts from './withProducts';
import { skus } from 'src/common/config/product';
import { findProductById, findProductVariant } from 'src/common/utils/product';
import { useProduct } from '../hooks';

const withProduct = compose(
  withProducts,
  withProductCustomisation,
  withQueryParams,
  mapProps(({ products, ...props }) => {
    const context = useProduct();

    const deprecatedProductId = props.productId || skus[props.productKey] || get(props, 'primary.productId');
    const productId = get(context, 'product.id', deprecatedProductId);

    // All these methods should be replace with the data that comes from the context
    const product = context || findProductById(products, productId);
    const productVariant = findProductVariant(get(product, 'variants'), props.productCustomisation);

    return {
      ...props,
      productId,
      product,
      productVariant,
    };
  }),
);

export default withProduct;
